import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

import { FavoriteOccupationsFacade } from '@cpd-app/state/favorite-occupations/favorite-occupations.facade';
import { tap } from 'rxjs/operators';
import { NavigationService } from '@cpd-app/core-module/services';
import { OccupationCard } from '@cpd-app/generated';

@Component({
  selector: 'cpd-saved-for-later-dialog',
  templateUrl: './saved-for-later-dialog.component.html',
  styleUrls: ['./saved-for-later-dialog.component.scss']
})
export class SavedForLaterDialogComponent implements OnInit {
  public favoriteOccupations$: Observable<OccupationCard[]>;

  constructor(
    private dialogRef: MatDialogRef<SavedForLaterDialogComponent>,
    private favoriteOccupationsFacade: FavoriteOccupationsFacade,
    private navigationService: NavigationService
  ) {}

  public ngOnInit(): void {
    this.favoriteOccupations$ =
      this.favoriteOccupationsFacade.favoriteOccupations$.pipe(
        tap((occupations) => {
          if (!occupations.length) {
            this.dialogRef.close();
          }
        })
      );
  }

  public onOccupationClick(occupation: OccupationCard) {
    this.navigationService.goToOccupationDetailPage(
      occupation,
      'buildYourTarget'
    );
    this.dialogRef.close();
  }
}
